import { render, staticRenderFns } from "./AppTestes.vue?vue&type=template&id=5f3e4c76&scoped=true&"
import script from "./AppTestes.vue?vue&type=script&lang=js&"
export * from "./AppTestes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e4c76",
  null
  
)

export default component.exports